document.addEventListener('DOMContentLoaded', function (){
    initDesignInspirationTooltips();
});

function initDesignInspirationTooltips() {
    const sections = document.querySelectorAll(`.product-design-inspiration`);

    sections.forEach(section => {
        const tooltips = section.querySelectorAll('.product-design-inspiration-tooltip');
        const slider = section.querySelector('.js-product-design-inspiration-content-slider');
        let swiperInstance;

        if (slider) {
            swiperInstance = new Swiper(slider, {
                loop: true,
                slidesPerView: 1,
                effect: 'fade',
                autoHeight: true,
                navigation: {
                    nextEl: slider.parentElement.querySelector('.swiper-btn.prev'),
                    prevEl: slider.parentElement.querySelector('.swiper-btn.next')
                },
                fadeEffect: {
                    crossFade: true
                },
                breakpoints: {
                    767: {
                        autoHeight: false,
                    }
                },
                on: {
                    slideChangeTransitionStart: () => {
                        let activeSlide = slider.querySelector('.swiper-slide-active');
                        let activeSlideId = activeSlide.getAttribute('data-id');

                        tooltips.forEach(tooltip => {
                            let tooltipSlideId = tooltip.getAttribute('data-slide-id');
                            tooltip.classList.toggle('active', tooltipSlideId === activeSlideId);
                            if(tooltipSlideId === activeSlideId){
                                let tooltipText = tooltip.querySelector('.tooltip-text');
                                let tooltipTextReact = tooltipText.getBoundingClientRect();
                                if(tooltipTextReact.right > window.innerWidth){
                                    tooltip.classList.add('reverse');
                                }
                            }
                        });
                    }
                }
            });
        }

        tooltips.forEach(tooltip => {
            tooltip.addEventListener('click', () => {
                tooltips.forEach(t => t.classList.remove('active'));
                tooltip.classList.add('active');

                let tooltipText = tooltip.querySelector('.tooltip-text');
                let tooltipTextReact = tooltipText.getBoundingClientRect();
                if(tooltipTextReact.right > window.innerWidth){
                    tooltip.classList.add('reverse');
                }

                let slideId = tooltip.getAttribute('data-slide-id');
                let slideIndex = Array.from(slider.querySelectorAll('.swiper-slide'))
                    .findIndex(slide => slide.getAttribute('data-id') === slideId);
                if (slideIndex !== -1) {
                    swiperInstance.slideTo(slideIndex);
                }
            });
        });
    });
}

